<div class="modal active">
  <div class="modal__container modal__container--md" style="top: 5%;">
    <div class="fields">
      <h2>Route Segments Import Options</h2>
      <div class="close" (click)="cancelImport()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngImportCsvForm" #ngForm="ngForm" id="importCsvForm" class="active" style="max-height: fit-content;">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Configured Fields To Import</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div style="max-height: 242px; overflow-y: auto; margin-bottom: 10px;">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Index</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr mdbTableCol *ngFor="let el of this.routeSegmentsService.model.table; let i = index">
                        <td>{{ el.name }}</td>
                        <td>
                          <input id="index_{{i}}"
                          name="index_{{i}}"
                          [(ngModel)]="el.index" value="el.index"/>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="input-fields">
                <div>
                  <label for="">Data Starting Line</label>
                  <input
                    style="max-width: 112px;"
                    maxlength="5"
                    [(ngModel)]="this.routeSegmentsService.model.dataStartingLine"
                    type="number"
                    name="dataStartingLine"
                    id="dataStartingLine"
                  />
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Field Separator</label>
                  <select
                      name="fieldSeparator"
                      [(ngModel)]="this.routeSegmentsService.model.fieldSeparator"
                    >
                      <option value=".">Dot (.)</option>
                      <option value=",">Comma (,)</option>
                      <option value=";">Semicolon (;)</option>
                      <option value="\t">Tab</option>
                      <option value=" ">Space</option>
                    </select>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Decimal Separator</label>
                  <select
                      name="decimalSeparator"
                      [(ngModel)]="this.routeSegmentsService.model.decimalSeparator"
                    >
                      <option value="Dot">Dot (.)</option>
                      <option value="Comma">Comma (,)</option>
                      <option value="Semicolon" selected>Semicolon (;)</option>
                    </select>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">

            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Layer Name</label>
                  <input
                    maxlength="30"
                    [(ngModel)]="this.routeSegmentsService.model.layerName"
                    type="text"
                    name="layerName"
                    id="layerName"
                    required
                  />
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Line Weight</label>
                  <input
                    maxlength="2"
                    [(ngModel)]="this.routeSegmentsService.model.lineWeight"
                    type="number"
                    name="layerWeight"
                    id="layerWeight"
                    style="width: 62%"
                  />
                  <span style="width: 8%">pixels</span>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Line Color</label>
                  <div>
                    <span style="width: auto; margin-right: 10px;display: inline-block;">{{ this.routeSegmentsService.model.lineColor}}</span>
                    <!-- <input
                      [style.background]="this.routeSegmentsService.model.lineColor"
                      [cpOKButton]="true"
                      [cpSaveClickOutside]="false"
                      [(colorPicker)]="this.routeSegmentsService.model.lineColor"
                      [cpOutputFormat]="'rgba'"
                      [cpOKButtonClass]= "'blue'"
                      name="lineColor"
                      id="lineColor"
                    /> -->
                    <input style="padding: 0px;" type="color" id="lineColor" name="lineColor" value={{this.routeSegmentsService.model.lineColor}} [(ngModel)]="this.routeSegmentsService.model.lineColor">
                  </div>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Line color for null val</label>
                  <div>
                    <span style="width: auto; margin-right: 10px;display: inline-block;">{{ this.routeSegmentsService.model.lineColorNullVal}}</span>
                    <!-- <input
                      [style.background]="this.routeSegmentsService.model.lineColorNullVal"
                      [cpOKButton]="true"
                      [cpSaveClickOutside]="false"
                      [(colorPicker)]="this.routeSegmentsService.model.lineColorNullVal"
                      [cpOutputFormat]="'rgba'"
                      [cpOKButtonClass]= "'blue'"
                      name="lineColor"
                      id="lineColorNullVal"
                    /> -->
                    <input style="padding: 0px;" type="color" id="lineColorNullVal" name="lineColorNullVal" value={{this.routeSegmentsService.model.lineColorNullVal}} [(ngModel)]="this.routeSegmentsService.model.lineColorNullVal">
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>CSV Source File</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File</label>
                  <input
                    style="padding-left: 0px;"
                    maxlength="300"
                    type="file"
                    name="filename"
                    id="filename"
                    (change)="saveFile($event)"
                    [accept]="importFormat.fileExtension"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="startImport();" [disabled]="!ngForm.form.valid">
              Import
            </button>
            <button class="gray" (click)="cancelImport()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
